var exports = {
  "V": "DirectionalIcons.module__mirrored___c3pvWX",
};

module.exports = exports;
